import axios, { AxiosError } from "axios"
import { LIST_PATH, APPROVAL_LEVEL_PATH } from "../../constants/paths"
import {
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
} from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CREDENTIALS_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getApprovalLevelsService = async () => {
  try {
    const result = await instance.get(APPROVAL_LEVEL_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const editApprovalLevelsService = async (
  approvalLevel: any,
  id: any
) => {
  try {
    const result = await instance.put(
      APPROVAL_LEVEL_PATH + `/${id}`,
      approvalLevel
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
